module.exports = __webpack_public_path__ + "img/subsc_12month02.14d7ca58.png";